module.exports = __webpack_public_path__ + "static/media/ts.12f0627e.jpeg";